import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-11 col-lg-6 d-flex w-md-50 align-items-center justify-content-center py-4 py-md-0 my-5" }
const _hoisted_2 = {
  key: 0,
  class: "position-relative",
  style: {"width":"290px"},
  id: "station-logo-container"
}
const _hoisted_3 = {
  id: "stations-vertical",
  class: "body text-grey-900 position-absolute text-start"
}
const _hoisted_4 = { class: "d-flex gap-1" }
const _hoisted_5 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_6 = { class: "body-strong text-grey-900" }
const _hoisted_7 = { class: "body text-grey-700" }
const _hoisted_8 = {
  style: {"color":"var(--primary-green)"},
  width: "8",
  height: "111",
  fill: "none"
}
const _hoisted_9 = { class: "position-absolute" }
const _hoisted_10 = {
  style: {"color":"var(--primary-blue)"},
  width: "112",
  height: "100",
  fill: "none"
}
const _hoisted_11 = {
  id: "summit-container",
  class: "body text-grey-900 position-absolute text-end"
}
const _hoisted_12 = { class: "d-flex gap-1" }
const _hoisted_13 = {
  style: {"color":"var(--primary-green)"},
  width: "56",
  height: "8",
  fill: "none"
}
const _hoisted_14 = { class: "d-flex flex-column gap-1 text-start" }
const _hoisted_15 = { class: "body-strong text-grey-900" }
const _hoisted_16 = { class: "body text-grey-700" }
const _hoisted_17 = {
  id: "station-distance-container",
  class: "body text-grey-900 position-absolute text-end"
}
const _hoisted_18 = { class: "d-flex gap-1" }
const _hoisted_19 = {
  style: {"color":"var(--primary-green)"},
  width: "56",
  height: "8",
  fill: "none"
}
const _hoisted_20 = { class: "d-flex flex-column gap-1 text-start" }
const _hoisted_21 = { class: "body-strong text-grey-900" }
const _hoisted_22 = { class: "body text-grey-700" }

import { onMounted } from 'vue';

interface MountainInfoLogoProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  content: Record<string, string>;
  isConnectedDomain: boolean;
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'MountainInfoLogo',
  props: {
    data: {},
    stationData: {},
    content: {},
    isConnectedDomain: { type: Boolean }
  },
  setup(__props: any) {

// Define types for the props
const props = __props;

// Add warnings for fallback data
onMounted(() => {
  
  if (props.isConnectedDomain) {
    // Check if any fallbacks are being used
    const usingFallbacks = 
      (!props.stationData.connectedNameDomainAltitudeDiff && props.stationData.altitudeDiff) ||
      (!props.stationData.connectedNameDomainMaxAltitude && props.stationData.maxAltitude) ||
      (!props.stationData.connectedNameDomainMinAltitude && props.stationData.minAltitude);
    
    if (usingFallbacks) {
      console.warn('MountainInfoLogo: Using fallback data for connected domain (altitude, max/min heights)');
    }
  }
  
  // Check if any required data is missing
  const missingData = [];
  if (!props.stationData.altitudeDiff) missingData.push('altitudeDiff');
  if (!props.stationData.maxAltitude) missingData.push('maxAltitude');
  if (!props.stationData.minAltitude) missingData.push('minAltitude');
  
  if (missingData.length > 0) {
    console.warn('MountainInfoLogo: Missing required data:', missingData);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.isConnectedDomain ? (_ctx.stationData.connectedNameDomainAltitudeDiff || _ctx.stationData.altitudeDiff) : _ctx.stationData.altitudeDiff)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.content.station_Vertical), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.isConnectedDomain ? (_ctx.stationData.connectedNameDomainAltitudeDiff || _ctx.stationData.altitudeDiff) : _ctx.stationData.altitudeDiff) + " " + _toDisplayString(_ctx.content.station_Metres), 1)
                ]),
                (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[0] || (_cache[0] = [
                  _createElementVNode("use", { href: "#___icon___vertical-green-dots-line" }, null, -1)
                ])))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[1] || (_cache[1] = [
                _createElementVNode("use", { href: "#___icon___two-mountains" }, null, -1)
              ])))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[2] || (_cache[2] = [
                  _createElementVNode("use", { href: "#___icon___horizontal-green-dots-line" }, null, -1)
                ]))),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.content.station_Height), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.isConnectedDomain ? (_ctx.stationData.connectedNameDomainMaxAltitude || _ctx.stationData.maxAltitude) : _ctx.stationData.maxAltitude) + " " + _toDisplayString(_ctx.content.station_Metres), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[3] || (_cache[3] = [
                  _createElementVNode("use", { href: "#___icon___horizontal-green-dots-line" }, null, -1)
                ]))),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.content.station_Resort), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.isConnectedDomain ? (_ctx.stationData.connectedNameDomainMinAltitude || _ctx.stationData.minAltitude) : _ctx.stationData.minAltitude) + " " + _toDisplayString(_ctx.content.station_Metres), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})